import { render, staticRenderFns } from "./AdminPartners.vue?vue&type=template&id=47ffd232&scoped=true"
import script from "./AdminPartners.vue?vue&type=script&lang=js"
export * from "./AdminPartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ffd232",
  null
  
)

export default component.exports